import Image from 'next/image';

import Button from '@/components/common/Button';

import CommonModal from '..';

export function contactUsShow() {
  CommonModal.show((t) => ({
    width: 600,
    footer: false,
    content: (close) => (
      <div className="flex flex-col items-center">
        <Image src="/images/qrcode.jpg" width={512} height={512} alt="" />

        <Button onClick={close} className="!font-normal !px-[48px] !w-fit mt-[30px]">
          {t('merror.operate.ok')}
        </Button>
      </div>
    ),
  }));
}
